
import * as React from 'react';
import { Route, Switch } from 'react-router';
import DashboardContainer from '../../Dashboard/DashboardContainer';
import EntityContainer from '../../Entity/EntityContainer';
import LoginContainer from '../../Login/LoginContainer';
import { ImplicitCallback, SecureRoute } from '@okta/okta-react';
import NotFoundView from './NotFoundVIew';
import RatePlanContainer from '../../RatePlans/RatePlanContainer';
import TransactionContainer from '../../Transaction/TransactionContainer';
import MembersContainer from '../../Members/MembersContainer';
import EntityReportContainer from '../../EntityReport/EntityReportContainer';
import LoginImageContainer from '../../LoginImage/LoginImageContainer';


const AppView: React.StatelessComponent =
  (props) =>
    (
      <Switch>
        <Route path='/' exact={true} component={LoginContainer} />
        <Route path='/implicit/callback' exact={true} component={ImplicitCallback} />
        <SecureRoute path='/branches/:branchId/' exact={true} component={DashboardContainer} />
        <SecureRoute path='/dashboard' exact={true} component={DashboardContainer} />
        <SecureRoute path='/entity/:entityId/' exact={true} component={EntityContainer} />
        <SecureRoute path='/rate-plans/' exact={true} component={RatePlanContainer} />
        <SecureRoute path='/add-transaction/' exact={true} key='add-transaction' component={TransactionContainer} />
        <SecureRoute path='/transaction/:transactionId' exact={true} component={TransactionContainer} />
        <SecureRoute path='/members' exact={true} component={MembersContainer} />
				<SecureRoute path='/balance-report' exact={true} component={EntityReportContainer} />
        <SecureRoute path='/login-image' exact={true} component={LoginImageContainer} />
        <Route component={NotFoundView} />
      </Switch>
    )

export default AppView
